import React from 'react';
import { motion } from 'framer-motion';

const BlogHero = () => {
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } }
  };

  return (
    <section className="bg-white pt-32 pb-16 border-b border-gray-100">
      <motion.div
        className="container-custom px-6"
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.15 }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <motion.p variants={itemVariants} className="text-sm uppercase tracking-[0.2em] text-gold font-semibold mb-4">
            Insights
          </motion.p>
          <motion.h1 variants={itemVariants} className="text-4xl md:text-6xl font-serif text-navy mb-6">
            Notes from building at the intersection of AI and real estate.
          </motion.h1>
          <motion.p variants={itemVariants} className="text-xl text-charcoal mb-8 leading-relaxed">
            Perspectives on PropTech, buyer behaviour, product building and the infrastructure behind modern real estate sales.
          </motion.p>
          <motion.div variants={itemVariants} className="flex flex-wrap justify-center gap-3">
            {['AI & PropTech', 'Buyer Intelligence', 'Product Building', 'Real Estate Sales'].map((topic) => (
              <span key={topic} className="px-4 py-2 bg-off-white text-navy text-sm rounded-full">
                {topic}
              </span>
            ))}
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default BlogHero;
